<template>
  <div 
    class="style-test" 
    :style="{background: `url(${comData.homePage.homeBackImg})`, backgroundSize: '100% 100%'}"
    v-if="comData.homePage.homeBackImg"
  >
    <img class="title-img" :src="comData.homePage.homeTitleImg" alt="" />
    <div class="center">
      <img class="master-map" :src="comData.homePage.homeVisionImg" alt="" />
      <img class="master-dynamicImg1" :src="comData.homePage.dynamicImg1" alt="" />
      <img class="master-dynamicImg2" :src="comData.homePage.dynamicImg2" alt="" />
      <img class="master-dynamicImg3" :src="comData.homePage.dynamicImg3" alt="" />
    </div>
    <img class="buttom" :src="comData.homePage.homeBtnImg" alt="" />
  </div>
  <img class="style-test"  v-else src="https://img3.quanyou.com.cn/joyNew/group1/M00/02/20/rB8LrmO9T9uAYGlHAAWfYRXlQK4297.png" alt="">
</template>

<script>
export default {
  props: {
    comData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  mounted() {
    console.log(this.comData)
  }
}
</script>

<style lang="stylus" scoped>
  .style-test {
    position: relative;
    width: 100%;
    height: 666px;
    display: flex;
    align-items: center;
    flex-direction: column;
    .title-img {
      width: 339px;
      height: 161px
      margin-top: 48px;
    }
    .center {
      position: relative;
      .master-map {
        width: 347px;
        height: 310px;
        margin-top: 15px;
      }
      .master-dynamicImg1 {
        position: absolute;
        left: -20px;
        top: 92px;
        width: 92px;
        height: 153px
      }
      .master-dynamicImg2 {
        position: absolute;
        right: -20px;
        top: 30px;
        width: 99px;
        height: 111px
      }
      .master-dynamicImg3 {
        position: absolute;
        right: -20px;
        top: 211px;
        width: 82px;
        height: 117px
      }
    }
    .bottom {
      position: absolute;
      bottom: 0;
      width: 375px;
      height: 158px;
    }
    .buttom {
      position: absolute;
      bottom: 46px;
      width: 119px;
      height: 46px;

    }
    
  }
</style>